import type { NavItem } from './navigation';
import { NAV_MORE } from './navigation';

/** Thumb destinations — companion IA (not a second product). */
export const MOBILE_TABS: readonly NavItem[] = [
  { to: '/', label: 'home', end: true, icon: 'home' },
  { to: '/screens', label: 'screens', icon: 'screens' },
  { to: '/content', label: 'library', icon: 'library' },
  { to: '/settings', label: 'account', icon: 'settings' },
] as const;

/**
 * Overflow from the header More control — primary destinations that are not
 * bottom tabs, then the existing More list.
 */
export const MOBILE_OVERFLOW: readonly NavItem[] = [
  { to: '/playlists', label: 'playlists', icon: 'playlists' },
  { to: '/schedule', label: 'schedule', icon: 'schedule' },
  ...NAV_MORE,
] as const;
